import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users } from "lucide-react";

/** Muestra el personal asignado a la sede elegida (si tiene) — se usa junto a
 * SiteSelect en Rondas y Cronograma para reflejar la asignación por sede. */
export function SiteAssignedHint({ clientId, siteId, roster = [] }) {
  const [site, setSite] = useState(null);

  useEffect(() => {
    if (!clientId || !siteId) { setSite(null); return; }
    (async () => {
      try {
        const { data } = await api.get(`/clients/${clientId}/sites`);
        setSite((data || []).find((s) => s.id === siteId) || null);
      } catch { setSite(null); }
    })();
  }, [clientId, siteId]);

  const ids = site?.assigned_vigilador_ids || [];
  if (!siteId || ids.length === 0) return null;
  const names = ids.map((id) => roster.find((r) => r.id === id)?.name).filter(Boolean);
  if (names.length === 0) return null;

  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 6, fontSize: 11, color: "var(--invict-text-muted)", margin: "-4px 0 12px", padding: "7px 9px", background: "var(--invict-bone-2)", borderRadius: 3 }} data-testid="site-assigned-hint">
      <Users size={12} style={{ marginTop: 1, flexShrink: 0, color: "#BF3437" }} />
      <span>Personal asignado a esta sede: <b style={{ color: "#0A0A0A" }}>{names.join(", ")}</b></span>
    </div>
  );
}
